import { Copy } from "lucide-react";
import { toast } from "react-toastify";

export default function RotateSecretModal({ isOpen, onClose, data }) {
  if (!isOpen) return null;

  const secret = data?.secretShownOnce || data?.secret || "";
  const keyPrefix = data?.keyPrefix || "";

  const copy = async () => {
    if (!secret) return;
    try {
      await navigator.clipboard.writeText(secret);
      toast.success("Copied");
    } catch {
      toast.error("Copy failed");
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black/40 flex items-center justify-center p-4">
      <div className="w-full max-w-lg rounded-lg bg-white border border-slate-200 shadow-xl">
        <div className="px-5 py-4 border-b border-slate-200">
          <h3 className="text-lg font-semibold text-slate-800">Secret Rotated</h3>
        </div>
        <div className="p-5 space-y-3">
          <p className="text-sm text-amber-700 bg-amber-50 border border-amber-200 rounded p-2">
            Secret is shown once. Save it securely now.
          </p>
          {keyPrefix ? (
            <p className="text-sm text-slate-700">
              Prefix: <span className="font-mono">{keyPrefix}</span>
            </p>
          ) : null}
          <div className="flex items-center gap-2">
            <code className="flex-1 rounded border border-slate-300 bg-slate-50 px-2 py-2 text-xs text-slate-700 break-all">
              {secret || "-"}
            </code>
            <button
              type="button"
              onClick={copy}
              className="inline-flex items-center gap-1 rounded border border-slate-300 px-2 py-2 text-xs hover:bg-slate-50"
            >
              <Copy size={14} /> Copy
            </button>
          </div>
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end">
          <button
            type="button"
            onClick={onClose}
            className="rounded-md bg-emerald-600 px-3 py-2 text-sm text-white"
          >
            Done
          </button>
        </div>
      </div>
    </div>
  );
}
